import React from 'react';
import {
    Paper, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Toolbar, Typography, IconButton, Box, Chip
} from '@mui/material';
import { Delete as DeleteIcon } from '@mui/icons-material';
import { useOCRStore } from '../store/ocrStore';

export const CustomFieldsTable: React.FC = () => {
    const { customFields, removeCustomField } = useOCRStore(
        state => ({
            customFields: state.customFields,
            removeCustomField: state.removeCustomField,
        })
    );

    if (customFields.length === 0) {
        return;
    }

    return (
        <Paper elevation={3} sx={{ mb: 3, borderRadius: 2, overflow: 'hidden' }}>
            <Toolbar sx={{ backgroundColor: 'primary.grey', color: 'primary.contrastText' }}>
                <Typography variant="h3" sx={{ flex: 1 }}>Manually Added Fields</Typography>
            </Toolbar>
            <TableContainer>
                <Table size="small" sx={{ minWidth: '100%', borderCollapse: 'collapse' }}>
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{ fontWeight: 'bold', borderBottom: '2px solid', borderColor: 'divider', p: 1.5 }}>Label</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', borderBottom: '2px solid', borderColor: 'divider', p: 1.5 }}>Data Type</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', borderBottom: '2px solid', borderColor: 'divider', p: 1.5, textAlign: 'right' }}>Actions</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {customFields.map((field, index) => (
                            <TableRow
                                key={field.id}
                                sx={{
                                    '&:nth-of-type(odd)': { backgroundColor: 'action.hover' },
                                    '&:hover': { backgroundColor: 'action.selected' },
                                }}
                            >
                                <TableCell sx={{ borderBottom: '1px solid', borderColor: 'divider', p: 1.5 }}>
                                    <Typography variant="body1">{field.label}</Typography>
                                </TableCell>
                                <TableCell sx={{ borderBottom: '1px solid', borderColor: 'divider', p: 1.5 }}>
                                    <Box display="flex" alignItems="center" gap={1}>
                                        <Chip label={field.dataType} size="small" variant="outlined" />
                                    </Box>
                                </TableCell>
                                <TableCell sx={{ borderBottom: '1px solid', borderColor: 'divider', p: 1.5, textAlign: 'right' }}>
                                    <IconButton onClick={() => removeCustomField(field.id)} color="error" size="small">
                                        <DeleteIcon />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Paper>
    );
};